
module.directive('userMenu', function(Principal) {
    return {
        restrict: 'E',
        templateUrl: 'page/userMenu',
        scope: {},
        link: function(scope, element, attrs) {
            scope.principal = Principal;
        },
    };
});
